import Card from '../Card/Card';
import './Popular_cabs.css';
import dinning_room from '../../images/Cab_photos/dining_room/2.jpg'
import chill_zone from '../../images/Cab_photos/chill_zone/IMG20250325112530.jpg'
import actzal from '../../images/Cab_photos/actzal/1.jpg'
import lib from '../../images/Cab_photos/library/2.jpg'

function Popular_Cabs() {
    return (
        <>
            <div className='title'><h1>Популярные места</h1></div>
            <div className='cards'>
                <Card name={'Столовая'} img={dinning_room} link={'/Dinning_room'}/>
                <Card name={'Зона отдыха'} img={chill_zone} link={'/Chill_room'}/>
                <Card name={'Библиотека'} img={lib} link={'/Library'}/>
                <Card name={'Актовый зал'} img={actzal} link={'/Zal'}/>
            </div>
        </>
    );
}

export default Popular_Cabs;